export const state = {
  locations: null,
};
